import angular from 'angular';
import tableGridTextCellComponent from './tableGridTextCell.component';

let tableGridTextCellModule = angular.module('tableGridTextCell', []).directive('tableGridTextCell', tableGridTextCellComponent);

export default tableGridTextCellModule;



// WEBPACK FOOTER //
// ./app/components/tableGridTextCell/tableGridTextCell.js